export default "__VITE_ASSET__dd377a78__"